"use client"

import { Button } from "@/components/ui/button"

export default function GlobalError({
                                        error,
                                        reset,
                                    }: {
    error: Error & { digest?: string }
    reset: () => void
}) {
    return (
        <html lang="fa" dir="rtl">
        <body>
        <div className="flex flex-col items-center justify-center min-h-screen space-y-4 p-4">
            <h2 className="text-xl font-semibold">مشکلی در سرور رخ داده است</h2>
            <Button
                variant="outline"
                onClick={reset}
            >
                تلاش مجدد
            </Button>
        </div>
        </body>
        </html>
    )
}